export default __webpack_public_path__ + "static/media/arrow_back_ios-24px.460680a2.svg";